export default __webpack_public_path__ + "static/media/Note.17dec28e.jpg";